const APP_ENDPOINTS = {
  BRANDS: '/brands',
  SETTINGS: '/settings',
  ACCOUNTS: (brand_id: string) => `/brands/${brand_id}/accounts`
};

export default APP_ENDPOINTS;
